import { CHEER_ICON_SIZE, cheerIconPixels } from "../../shared/cheers.ts";

const POPPED = cheerIconPixels(true);
const READY = cheerIconPixels(false);

/**
 * The party popper beside the Cheer word (docs/cheers.md, shared/cheers.ts CHEER_ICON): 9x9 art pixels
 * drawn as crisp rects, `scale` CSS pixels each. The popper alone before you have cheered, gone off with
 * its confetti once you have. Decorative; the button's name and state say what it means.
 */
export function CheerIcon({ popped, scale = 2, className }: { popped: boolean; scale?: number; className?: string }) {
  const pixels = popped ? POPPED : READY;
  const size = CHEER_ICON_SIZE * scale;
  return (
    <svg class={className ?? "cheer-icon"} width={size} height={size} viewBox={`0 0 ${CHEER_ICON_SIZE} ${CHEER_ICON_SIZE}`} shape-rendering="crispEdges" aria-hidden="true" focusable="false">
      {pixels.map((p) => (
        <rect key={`${p.x}-${p.y}`} x={p.x} y={p.y} width="1" height="1" fill={p.fill} />
      ))}
    </svg>
  );
}
